import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {accountUsersAPI} from '../../../../services/AccountUsersService'
import {toAbsoluteUrl} from '../../../../template/helpers'

/* eslint-disable jsx-a11y/anchor-is-valid */
type InviteState = 'idle' | 'accepting' | 'done' | 'failed'

export function InviteAccept() {
  const {token} = useParams()
  const navigate = useNavigate()
  const [acceptInvite] = accountUsersAPI.useAcceptInviteMutation()
  const [state, setState] = useState<InviteState>('idle')

  useEffect(() => {
    if (!token || state !== 'idle') return
    setState('accepting')
    acceptInvite({token})
      .unwrap()
      .then(() => setState('done'))
      .catch(() => setState('failed'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const goToApps = () => navigate('/apps', {replace: true})
  const goToLogin = () => navigate('/auth/login', {replace: true})

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/callbee_logo.png')} className='h-45px' />
        </a>
        <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>
          {state === 'accepting' && (
            <div className='text-center py-10'>
              <span className='spinner-border text-primary'></span>
              <div className='text-muted mt-4'>Проверяем приглашение…</div>
            </div>
          )}

          {state === 'done' && (
            <div className='text-center py-5'>
              <span className='svg-icon svg-icon-3x text-success mb-6 d-block'>
                <i className='fas fa-check-circle fs-2tx'></i>
              </span>
              <h3 className='text-gray-900 fw-bolder mb-3'>Приглашение принято</h3>
              <p className='text-muted mb-8'>Вы присоединились к аккаунту.</p>
              <button className='btn btn-primary' onClick={goToApps}>
                Перейти в приложение
              </button>
            </div>
          )}

          {state === 'failed' && (
            <div className='text-center py-5'>
              <span className='svg-icon svg-icon-3x text-danger mb-6 d-block'>
                <i className='fas fa-times-circle fs-2tx'></i>
              </span>
              <h3 className='text-gray-900 fw-bolder mb-3'>Ссылка недействительна</h3>
              <p className='text-muted mb-8'>Приглашение истекло, уже использовано или не существует.</p>
              <button className='btn btn-primary' onClick={goToLogin}>
                Войти в аккаунт
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
